export interface CheckoutRequestDto {
  customerId?: string;
  officeId: number;
  email: string;
}

export class StripePaymentMethodFormDto {
  id: string | null = null;
  officeId: number | null = null;
  cardToken: string | null = null;
  name: string | null = null;
  email: string | null = null;
  zipCode: string | null = null;
  isDefault: boolean = false;
}

export interface StripeInfoDto {
  price: StripePriceInfoDto;
  activeSubscription: StripeSubscriptionInfoDto | null;
  paymentMethods: StripePaymentMethodDto[];
  paymentHistory: StripePaymentDto[];
}

export interface StripePriceInfoDto {
  id: string;
  amount: number;
  productName: string;
}

export interface StripeSubscriptionInfoDto {
  id: string;
  name: string;
  amount: number;
  renewDate: Date;
  isCancelled: boolean;
}

export interface StripePaymentMethodDto {
  id: string;
  lastFourDigits: string;
  isDefault: boolean;
}

export interface StripePaymentDto {
  amount: number;
  date: Date;
}